import { useAppSelector } from '../../hooks';
import { UserDetails } from '../../models/analytics';

import {
  getUserAnonymisedId,
  getUserRoleIdentifier,
} from '../../utils/analytics';

/**
 * Returns an object containing user details such as role and anonymised user ID.
 * @returns {UserDetails} The user details object.
 */
export default function useUserRoleAndShortId(): UserDetails {
  const idToken = useAppSelector((state) => state.user.idToken);
  const role = getUserRoleIdentifier(idToken);
  const userAnonymisedId = getUserAnonymisedId(idToken);
  const companyName = idToken?.company_name || null;
  const jobTitle = idToken?.job_title || null;
  return { role, userAnonymisedId, companyName, jobTitle };
}
